import { render, staticRenderFns } from "./NumberMappingTables.vue?vue&type=template&id=19c4acf0"
import script from "./NumberMappingTables.vue?vue&type=script&lang=js"
export * from "./NumberMappingTables.vue?vue&type=script&lang=js"
import style0 from "./NumberMappingTables.vue?vue&type=style&index=0&id=19c4acf0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports